import React, { useContext, useState } from 'react';
import {Table, Button } from 'react-bootstrap';
import { Link, Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import MRISurgeonList from './MRI/mriSurgeonList';
import SurgeonCaseList from './Surgeon/patientCasesList';
import SurgeonCreateCasePage from './surgeoncreatecase';

import MRIList from './MRI/mriList';
import MRICasePage from './mricenter';
import { AuthorizeContext } from "../RootContext";
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: 'calc(100vh - 72px)',
    boxSizing: 'border-box',
    padding: '34px 28px 54px',
    background:
      'radial-gradient(circle at 8% 2%, rgba(43, 181, 171, 0.12) 0, transparent 30%), radial-gradient(circle at 92% 0%, rgba(42, 123, 184, 0.11) 0, transparent 30%), linear-gradient(180deg, #f8fbfc 0%, #eef5f7 100%)',
    color: '#173247',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',

    '& .surgeon_main_layout': {
      width: '100% !important',
      maxWidth: '1540px !important',
      margin: '0 auto !important',
      padding: '0 !important',
      float: 'none !important',
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1.6fr) minmax(320px, 0.9fr)',
      gap: 24,
      background: 'transparent',
    },

    '& .surgeon_main_layout > .col-md-8': {
      width: '100% !important',
      maxWidth: '100% !important',
      float: 'none !important',
      padding: '6px 26px 24px !important',
      overflow: 'hidden',
      borderRadius: 18,
      background: '#ffffff',
      border: '1px solid #dce7ec',
      boxShadow: '0 14px 34px rgba(19, 62, 83, 0.08)',
    },

    '& .surgeon_main_layout > .col-md-8::before': {
      content: '"Account Information"',
      display: 'block',
      margin: '-6px -26px 6px',
      padding: '24px 26px 18px',
      borderBottom: '1px solid #e7eef1',
      background: 'linear-gradient(90deg, #ffffff 0%, #f5fafb 100%)',
      color: '#173247',
      fontSize: 24,
      lineHeight: 1.2,
      fontWeight: 800,
      letterSpacing: '-0.02em',
    },

    '& .surgeon_main_layout > .col-md-8 > div > .col-md-7': {
      width: '100% !important',
      maxWidth: '100% !important',
      float: 'none !important',
      display: 'grid',
      gridTemplateColumns: '180px minmax(0, 1fr)',
      gap: 18,
      padding: '17px 0 !important',
      margin: '0 !important',
      borderBottom: '1px solid #edf2f4',
    },

    '& .surgeon_main_layout > .col-md-8 > div:last-child > .col-md-7': {
      borderBottom: '0',
    },

    '& .surgeon_main_layout > .col-md-8 .col-md-6': {
      width: '100% !important',
      maxWidth: '100% !important',
      float: 'none !important',
      minWidth: 0,
      padding: '0 !important',
      color: '#173247',
      fontSize: 15,
      fontWeight: 650,
      lineHeight: 1.5,
      overflowWrap: 'anywhere',
    },

    '& .surgeon_main_layout > .col-md-8 .col-md-6:first-child': {
      color: '#60798a',
      fontSize: 13,
      fontWeight: 800,
    },

    '& .surgeon_main_layout > .col-md-4': {
      width: '100% !important',
      maxWidth: '100% !important',
      float: 'none !important',
      padding: '24px !important',
      overflow: 'hidden',
      borderRadius: 18,
      background: '#ffffff',
      border: '1px solid #dce7ec',
      boxShadow: '0 14px 34px rgba(19, 62, 83, 0.08)',
    },

    '& .surgeon_main_layout > .col-md-4::before': {
      content: '"Quick Actions"',
      display: 'block',
      margin: '-24px -24px 20px',
      padding: '24px 26px 18px',
      borderBottom: '1px solid #e7eef1',
      background: 'linear-gradient(90deg, #ffffff 0%, #f5fafb 100%)',
      color: '#173247',
      fontSize: 24,
      lineHeight: 1.2,
      fontWeight: 800,
      letterSpacing: '-0.02em',
    },

    '& .surgeon_main_layout > .col-md-4 > .row': {
      display: 'block !important',
      width: '100% !important',
      height: 'auto !important',
      minHeight: '0 !important',
      margin: '0 0 12px !important',
      padding: '0 !important',
      flex: '0 0 auto !important',
    },

    '& .surgeon_main_layout > .col-md-4 > .row:empty': {
      display: 'none',
    },

    '& .surgeon_main_layout .button-info': {
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'flex-start !important',
      width: '100% !important',
      height: '58px !important',
      minHeight: '58px !important',
      maxHeight: '58px !important',
      flex: '0 0 58px !important',
      margin: '0 !important',
      padding: '0 18px !important',
      boxSizing: 'border-box',
      borderRadius: '12px !important',
      border: '1px solid #d5e4ea !important',
      background: '#ffffff !important',
      color: '#173247 !important',
      fontSize: '15px !important',
      fontWeight: '800 !important',
      textDecoration: 'none !important',
      boxShadow: 'none !important',
      transition:
        'transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease, background 140ms ease',
    },

    '& .surgeon_main_layout .button-info:hover': {
      color: '#173247 !important',
      textDecoration: 'none !important',
      transform: 'translateY(-1px)',
      borderColor: '#9dcbd5 !important',
      background: '#f8fcfd !important',
      boxShadow: '0 10px 24px rgba(19, 98, 119, 0.10) !important',
    },

    '& .surgeon_main_layout > .col-md-4 > .row:first-child .button-info': {
      color: '#ffffff !important',
      borderColor: 'transparent !important',
      background: 'linear-gradient(135deg, #169bb7 0%, #0d718c 100%) !important',
      boxShadow: '0 10px 22px rgba(13, 113, 140, 0.20) !important',
    },

    '& .surgeon_main_layout > .col-md-4 > .row:first-child .button-info:hover': {
      color: '#ffffff !important',
      borderColor: 'transparent !important',
      background: 'linear-gradient(135deg, #138ca6 0%, #0a637a 100%) !important',
      boxShadow: '0 13px 28px rgba(13, 113, 140, 0.26) !important',
    },

    '& .surgeon_main_layout > .col-md-12': {
      gridColumn: '1 / -1',
      width: '100% !important',
      maxWidth: '100% !important',
      float: 'none !important',
      top: 'auto !important',
      marginTop: '0 !important',
      padding: '15px 18px !important',
      borderRadius: 12,
      background: 'rgba(255,255,255,0.72)',
      border: '1px solid #dce7ec',
      color: '#708795',
      fontSize: 12,
      lineHeight: 1.5,
    },

    '& .surgeon_main_layout > .col-md-12 sub': {
      color: '#708795 !important',
      fontSize: '12px !important',
    },

    [theme.breakpoints.down('md')]: {
      '& .surgeon_main_layout': {
        gridTemplateColumns: '1fr',
      },

      '& .surgeon_main_layout > .col-md-12': {
        gridColumn: '1',
      },
    },

    [theme.breakpoints.down('sm')]: {
      padding: '22px 16px 38px',
    },

    [theme.breakpoints.down('xs')]: {
      '& .surgeon_main_layout > .col-md-8 > div > .col-md-7': {
        gridTemplateColumns: '1fr',
        gap: 5,
        padding: '14px 0 !important',
      },
    },
  },

  shell: {
    width: '100%',
    maxWidth: 1540,
    margin: '0 auto',
  },

  hero: {
    position: 'relative',
    overflow: 'hidden',
    marginBottom: 24,
    padding: '30px 32px',
    borderRadius: 20,
    color: '#ffffff',
    background: 'linear-gradient(135deg, #123b5d 0%, #0d718c 58%, #159b98 100%)',
    border: '1px solid rgba(255,255,255,0.18)',
    boxShadow: '0 18px 44px rgba(18, 74, 103, 0.18)',

    '&::after': {
      content: '""',
      position: 'absolute',
      width: 250,
      height: 250,
      right: -80,
      top: -118,
      borderRadius: '50%',
      border: '34px solid rgba(255,255,255,0.07)',
      pointerEvents: 'none',
    },
  },

  eyebrow: {
    position: 'relative',
    zIndex: 1,
    margin: 0,
    color: 'rgba(255,255,255,0.76)',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },

  heroTitle: {
    position: 'relative',
    zIndex: 1,
    margin: '7px 0 0',
    color: '#ffffff',
    fontSize: 34,
    lineHeight: 1.15,
    fontWeight: 800,
    letterSpacing: '-0.035em',
  },
}));

const ReadOnlyHomePage = () => {
  const classes = useStyles();
  const { user, authBody } = useContext(AuthorizeContext);

  const [profile, setProfile] = useState(authBody || {role: "visitor"})
  let { path, url } = useRouteMatch();


  const hasRole = (profile, roles) =>{
    return roles.includes(profile.role)
  }

  return(
    <>
    <main className={classes.page}>
      <div className={classes.shell}>
        <section className={classes.hero}>
          <p className={classes.eyebrow}>
            {hasRole(profile, ['hospital']) ? 'Hospital Portal' : hasRole(profile, ['distributor']) ? 'Distributor Portal' : 'Partner Portal'}
          </p>
          <h1 className={classes.heroTitle}>
            Welcome{user && (user.First_Name || user.Last_Name) ? `, ${user.First_Name || user.Last_Name}` : ''}
          </h1>
        </section>
    <div className="surgeon_main_layout col-lg-9">
      <div className="col-md-8">
      <div>
        <div className="col-md-7">
          <div className="col-md-6">
          <b>User:</b>
          </div>
          <div className="col-md-6">
          {user.Last_Name}, {user.First_Name}
          </div>
        </div>
      </div>
      <div>
        <div className="col-md-7">
          <div className="col-md-6">
          <b>Office Name:</b>
          </div>
          <div className="col-md-6">
          {user.Office_Name}
          </div>
        </div>
      </div>
      <div>
        <div className="col-md-7">
          <div className="col-md-6">
          <b>Office Address:</b>
          </div>
          <div className="col-md-6">
          {user.Street}
          <br />
          {user.City}, {user.State_Province}
          <br />
          {user.Postal_Code}, {user.Country}
          </div>
        </div>
      </div>
      <div>
        <div className="col-md-7">
          <div className="col-md-6">
          <b>Email Address:</b>
          </div>
          <div className="col-md-6">
          {user.Email_Address}
          </div>
        </div>
      </div>
      <div>
        <div className="col-md-7">
          <div className="col-md-6">
          <b>Phone Number:</b>
          </div>
          <div className="col-md-6">
          {user.Phone}
          </div>
        </div>
      </div>
      <div>
        <div className="col-md-7">
          <div className="col-md-6">
          <b>Fax Number:</b>
          </div>
          <div className="col-md-6">
          {user.Fax}
          </div>
        </div>
      </div>
      </div>
      <div className="col-md-4">
        <div className="row">
          <Link type="button" to={`/active-case-list`} className="btn btn-primary button-info">
          {
            hasRole(profile, ['hospital']) ?
            "SURGERY ORDERS"

            :

            "ACTIVE ORDERS"

          }
          </Link>
        </div>
        <div className="row">
          <Link type="button" to={`/completed-case-list`} className="btn btn-primary button-info">COMPLETED ORDERS</Link>
        </div>
        <div className="row">
          {
            hasRole(profile, ['distributor']) ?
            <Link type="button" to={`/abort-case-list`} className="btn btn-primary button-info">ABORTED ORDERS</Link>

            :

            null

          }
        </div>
         <div className="row">

        </div>
         <div className="row">
        </div>
       {/* { hasRole(profile,'distributor') &&
         <div className="row">
           <Link type="button" to='/surgeon/create' className="btn btn-info button-info" role="button" >NEW SURGEON</Link>
        </div>
        }*/}
      </div>
      <div className="col-md-12" style={{textAlign: 'center', top: '2em'}}>
        <sub
        style={{color: '#888888'}}
        >For any comment, question, or modification request, please contact info@lentomedical.com
        </sub>
      </div>
      <Switch>
      <Route path={`/case/create`} component={SurgeonCreateCasePage}/>
      <Route path={`/surgeonPref/`} component={SurgeonCreateCasePage}/>

      <Route path={`${url}/casesl`} component={SurgeonCaseList} />
      </Switch>
      </div>
      </div>
    </main>
      </>

  );
}

export default ReadOnlyHomePage;